import Axios from "axios";
import React, { Component } from "react";
import { Alert, Button, Form } from "react-bootstrap";

export default class CreateFolderForm extends Component {
    state = {
        error: null,
    };

    onSubmit = (event) => {
        event.preventDefault();
        event.stopPropagation();
        const form = event.currentTarget;
        const folderName = form["folderName"].value?.trim();
        if (!!folderName && this.props.folderId) {
            Axios.post(process.env.REACT_APP_BACKEND_URL + "/folder", {
                name: folderName,
                parent: this.props.folderId,
            }).then(() => {
                form.reset();
                if (typeof this.props.refetchData === 'function') {
                    this.props.refetchData();
                }
            }).catch(({ response }) => {
                const errorMsg = response?.data?.message || '';
                this.setState({
                    error: {
                        title: "Error Creating Folder!",
                        body: "Server reported an error: " + errorMsg,
                    }
                });
            });
        }
    };

    render() {
        const { error } = this.state;
        return (
            <>
                <Form onSubmit={this.onSubmit} className="d-flex align-items-center mt-5">
                    <Form.Control id="folderName" type="text" placeholder="New Folder..." required style={{ width: '60%' }} />
                    <Button variant="primary" type="submit" className="ms-2">
                        + New Folder
                    </Button>
                </Form>
                {error ? (
                    <Alert 
                        className="mx-auto alert-top-right w-50" 
                        variant="danger" 
                        onClose={() => { this.setState({ error: null }) }} 
                        dismissible
                    >
                        <Alert.Heading>{error?.title}</Alert.Heading>
                        <p>{error?.body}</p>
                    </Alert>
                ) : (
                    <></>
                )}
            </>
        )
    }
}